import moment from "moment";

const isIsoDateString = (value) =>
  typeof value === "string" && moment(value, moment.ISO_8601, true).isValid();

/** Convierte Moment/Date/fechas ISO a string serializable para Redux. */
export const toSerializableDate = (value) => {
  if (value == null || value === "") return value;
  if (moment.isMoment(value)) return value.toISOString();
  if (value instanceof Date) return value.toISOString();
  if (isIsoDateString(value)) return moment(value).toISOString();
  return value;
};

/** Recorre objetos/arrays y serializa fechas (evita Moment en el store). */
export const serializeDatesDeep = (value) => {
  if (value == null) return value;

  if (moment.isMoment(value) || value instanceof Date) {
    return toSerializableDate(value);
  }

  if (isIsoDateString(value)) {
    return moment(value).toISOString();
  }

  if (Array.isArray(value)) {
    return value.map(serializeDatesDeep);
  }

  if (typeof value === "object") {
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = serializeDatesDeep(value[key]);
      return acc;
    }, {});
  }

  return value;
};
